import React, { useState } from "react";
import { Tab, Tabs } from "react-bootstrap";
import CompanyIncomingInvoices from "./companyIncomingInvoices";
import CompanyOutgoingInvoices from "./companyOutgoingInvoices";
import AdminDashboard from "./admindashboard";

function CompanyInvoicesTab({ selectedOrgcode }) {
  const [activeTab, setActiveTab] = useState("incomingInvoices");
  let companycode = ""; 

  if (selectedOrgcode) {
    companycode = selectedOrgcode;
  } else {
    companycode = JSON.parse(localStorage.getItem("data"))?.orgcode || "";
  }
  const userRole = JSON.parse(localStorage.getItem("data"))?.role; 

  return (
    <>
      {userRole === "ROLE_EMPLOYER" && <AdminDashboard />}
      
      <div className={`col-12 mx-xl-auto ${userRole ==="ROLE_EMPLOYER" ? "ps-xl-10 mt-10" : ""}`}>
        <div className="card card-raised">
          <div className="card-body">
          <Tabs
            id="invoices-tabs"
            activeKey={activeTab}
            onSelect={(tab) => setActiveTab(tab)}
            className="mb-3"
          >
            <Tab eventKey="incomingInvoices" title="Incoming Invoices">
            {activeTab === 'incomingInvoices' && <CompanyIncomingInvoices selectedOrgcode={companycode} />}
            </Tab>
            <Tab eventKey="outgoingInvoices" title="Outgoing Invoices">
            {activeTab === 'outgoingInvoices' && <CompanyOutgoingInvoices selectedOrgcode={companycode} />}
            </Tab>
          </Tabs>
        </div>
      </div>
    </div>
    </>
  );
}

export default CompanyInvoicesTab;
